<template>
  <div class="popular-dish-card">
    <div class="popular-dish-card-image-container">
      <base-image
        v-if="card.image?.src"
        :desktop-url="card.image.src"
        :desktop-alt="card.image.alt"
        :custom-params="{ desktop: 500, tablet: 400, mobile: 715, mobileS: 430 }"
        class="popular-dish-card-image"
      />
    </div>
    <div class="popular-dish-card-content">
      <h3 v-if="card.title" class="popular-dish-card-content__title">{{ card.title }}</h3>
      <p
        v-if="card.description"
        :key="card.description"
        v-truncate-text="{
          dynamicText: card.description,
          maxLength: 108,
          showMoreText: t('introduction-show-more'),
          showLessText: t('introduction-show-less'),
          buttonClass: 'popular-dish-card-content__link link',
        }"
        class="popular-dish-card-content__description"
      >
        {{ card.description }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PopularDishCardProps } from '../types';
import BaseImage from '../../../2_elements/BaseImage/BaseImage.vue';
import vTruncateText from '../../../../directives/vTruncateText';
import { useI18n } from 'vue-i18n';

defineProps<PopularDishCardProps>();
const { t } = useI18n();
</script>

<style lang="scss">
@import './scss/PopularDishCard.scss';
</style>
